<script>
    // import {flow_info, flow_stack} from './stores.js';
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    // import Listcomponent from './components/listcomponent.svelte';
    import Listcomponent from './components/listcomponent.svelte';
    export let listdata = [
        {s: true, t: "0-3 Months", cbf:()=>{$user_data.whenplanningtopurchase = "0-3 Months";}},
        {s: true, t: "3-6 Months", cbf:()=>{$user_data.whenplanningtopurchase = "3-6 Months";}},
        {s: true, t: "6+ Months", cbf:()=>{$user_data.whenplanningtopurchase = "6+ Months";}},
        {s: true, t: "I'm not sure", cbf:()=>{$user_data.whenplanningtopurchase = "I'm not sure";}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
show_icon_card={true}
>
    <Progresscomponent 
    title="When are you planning to purchase?"
    show_next_button={false}
    >
    <Listcomponent
        bind:listdata={listdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>